import axios from "axios";

import {
  ResponseList,
  ResponseItem,
  ResponseRemove,
} from "../../models/clientModels/interfaces/Response";
import * as Params from "../../models/clientModels/interfaces/apiParams";
import {KPPost} from "../../models/serverModels/board/KPPost";

const Board = axios.create({
  baseURL: "/api",
});

export const getItem = async (params: Params.GetItem): Promise<ResponseItem<KPPost>> =>
  Board({
    url: `/Post/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);

export const create = async (params: Params.Create<KPPost>): Promise<ResponseItem<KPPost>> =>
  Board({
    url: `/Post`,
    method: "post",
    data: params,
  }).then((res) => res.data);

export const remove = async (params: Params.Remove): Promise<ResponseRemove> =>
  Board({
    url: `/Post/${params.id}`,
    method: "delete",
    data: params,
  }).then((res) => res.data);

export const update = async (params: Params.Update<KPPost>): Promise<ResponseItem<KPPost>> =>
  Board({
    url: `/Post/${params.id}`,
    method: "put",
    data: params,
  }).then((res) => res.data);
